"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _componentSvg = require("@wel-ui/component-svg");

var _componentSvg2 = _interopRequireDefault(_componentSvg);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Icon = function Icon(props) {
  return _react2.default.createElement(_componentSvg2.default, props, Icon.svg);
};

Icon.propTypes = {
  height: _propTypes2.default.number,
  label: _propTypes2.default.string,
  width: _propTypes2.default.number
};

Icon.displayName = "UiArrowRight";

Icon.svg = _react2.default.createElement(
  "svg",
  { viewBox: "0 0 24 24" },
  _react2.default.createElement(
    "g",
    {
      className: "nc-icon-wrapper",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2"
    },
    _react2.default.createElement("path", {
      d: "M2 12h20",
      "data-cap": "butt",
      "data-color": "color-2"
    }),
    _react2.default.createElement("path", {
      d: "M15 5l7 7-7 7",
      strokeLinecap: "square"
    })
  )
);

exports.default = Icon;



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/icons/lib/ui/arrow-right.js
// module id = 374
// module chunks = 0